<!--This Component shown to warn AFPs that they are missing a Sepio Guard API producer number-->
<template>
	<div class="mr-12 flex cursor-pointer items-center">
		<ExclamationTriangleIcon class="mr-2 size-4 text-yellow-600" />
		<p class="text-sm text-yellow-600">Sepio Account</p>
	</div>
</template>

<script setup lang="ts">
import { ExclamationTriangleIcon } from '@heroicons/vue/24/solid'
</script>

<style scoped></style>
